// Environment
const initialState = {
    rects: []
}

export const rectsReducer = (state = initialState, action) => {
    switch(action.type) {
        case "SET_RECTS":
            return {
                ...state,
                rects: action.rects
            }
        default: return state;
    }
};
